import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TooltipService {
  constructor(private readonly translate: TranslateService) {}

  getTooltip(key: string): string {
    const translationKey = `tooltips.${key}`;
    const translated = this.translate.instant(translationKey);
    return translated === translationKey ? 'No help available for this field.' : translated;
  }
}
